export default {"src":"/_next/static/media/bootstrap.9e6ddba8.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};